/**
 * /frontend/src/features/analytics/hooks/useOfferFunnel.js
 */

import { useCallback, useMemo } from 'react';
import { getOfferFunnel } from '../api/offerAnalyticsApi';
import useAnalyticsResource from './useAnalyticsResource';

/**
 * Loads funnel metrics for a specific offer.
 * @param {Object} params
 * @returns {{data:any,isLoading:boolean,isError:boolean,error:any,refetch:Function}}
 */
const useOfferFunnel = (params = {}) => {
  const { request, storeToken, offerId, startDate, endDate, refreshSignal } = params;
  const enabled = Boolean(request && offerId);

  const fetcher = useCallback(
    async () => getOfferFunnel(request, storeToken, offerId, startDate, endDate),
    [endDate, offerId, request, startDate, storeToken]
  );
  const resource = useAnalyticsResource(enabled, fetcher, 'useOfferFunnel', refreshSignal);
  return useMemo(() => resource, [resource]);
};

export default useOfferFunnel;
